

const CALLCENTRAL_CONSTANTS = {
  ADMIN_URL: window._env_ && window._env_.REACT_APP_ADMIN,
};
const STORAGE = {
  0: sessionStorage,
  1: localStorage,
};
const COMPONENTS = {
  REQUEST_COVERAGE: "RequestCoverage",
  SWAP_CALL: "SwapCall",
  ONCALL_LOOK_UP: "OnCallLookUp",
  HOME: "Home",
  UNASSIGNED_SHIFT: "UnassignedShift",
  GROUP_SMS: "GroupSms",
  STATUS_BOARD: "StatusBoard",
  FILE_SHARE: "FileShare",
  DAY_VIEW_WRAPPER: "DayViewWrapper",
  SCHEDULE_CONTROLLER: "ScheduleController",
};
const MESSAGES = {
  START_A_CASE: "Patient Details Added successfully",
  UNLINK_USER: "Unlinked successfully",
  DELETE_TEAM: "Team deleted successfully",
  PATIENT_TRANSFER: "Patient transfer completed successfully",
  MRN: "MRN added successfully",
  UNASSIGNED_REMOVE_CONFIRMATION:
    "Are you sure you want to remove this shift from completed?",
  SIGN_IN_VALIDATION: "Invalid credentials or You don't have enough permission",
  ASSIGNED_USER_SUCCESS: "Users assigned successfully",
  ASSIGNED_USER_ERROR: "Error in  assigning users",
  UNASSIGNED_REQUEST_COVER_SUCCESS: "Request coverage sent successfully",
  UNASSIGNED_REQUEST_COVER_ERROR: "Request coverage sent failed",
  GROUP_SMS_SUCCESS: "Message sent successfully",
  SMS_SUCCESS: "Your message has been sent successfully",
  SMS_FAILED: "Message sending failed, Please check the contact number",
  PROFILE_UPDATE_FAILED: "Failed to update profile",
  EMS_RESENT_REQUEST: "Resend request updated ",
  COLUMN_DELETE_CONFIRMATION:
    "Are you sure you want to delete selected column?",
  INVALID_NAME: "Please enter a valid column name",
  CUSTOM_COLUMNS_ADDED: "Custom column added successfully",
  CUSTOM_COLUMNS_DELETED: "Custom column deleted successfully",
  CUSTOM_COLUMNS_UPDATED: "Custom column updated successfully",
  ADD_PATIENT: "Added patient successfully!",
  PROVIDER_SCHEDULE_ALREADY_PRESENT: "Provider's schedule already exists",
  EDIT_PATIENT: "Updated patient successfully!",
  DISCHARGE_SUCCESS: "Discharged patient successfully!",
  DISCHARGE_CONFIRMATION: {
    TITLE: "Confirm Discharge",
    MESSAGE: "Are you sure you want to discharge the patient?",
  },
  SELECT_FILTER_OPTION: "Please select a filter option",
  REMOVE_CARD_CONFIRMATION: "Are you sure you want to delete the provider?",
  REMOVE_USER_CONFIRMATION: "Are you sure you want to remove the user?",
  REMOVE_SCHEDULE_CONFIRMATION: "Are you sure you want to remove the schedule?",
  SELECT_SINGLE_GROUP: "Please select a single schedule to proceed",
  NO_CONTACT: "No contact details available for the selected user!",
  ADD_PROVIDER_NOT_ON_CALL: "No assigned call coverage",
  SUPPORT_STAFF_CONFIRMATION: "Are you sure you want to delete support staff?",
  CARETEAM_NOTIFICATION_SUCCESS: "Notification sent to ",
  ADDED_FAVORITE_SUCCESS: "Added successfully",
  USER_IN_FAVORITES: "Selected user is already in favorite list",
  UPDATED_FAVORITE_SUCCESS: "Updated successfully",
  DELETED_FAVORITE_SUCCESS: "Deleted successfully",
  MEDIA_FORWARD_SUCCESS: "Media forwarded",
  MESSAGE_FORWARD_SUCCESS: "Message forwarded",
  NO_AUDIO_DEVICE: "No audio recording device found",
  NO_VIDEO_DEVICE: "No video recording device found",
  MEDIA_UPLOAD_SUCCESS: "Message sent successfully",
  SESSION_EXPIRED: "Session Expired : Please login again",
  MANAGE_AVAILABILITY_HEADER: "Manage Availability Options",
  MANAGE_AVAILABILITY_MESSAGE:
    "Please choose Template option if you want to set template. To continue Manage Availability, choose Manage Availability option",
  PATIENT_ASSIGN_ERROR: "Patient not assigned : No assigned call coverage ",
  DEFAULT_ERROR_MESSAGE: "Something went wrong, please contact admin",
  PROCEED_TO_APP: "Do you want to proceed to Nserix application",
  PLEASE_SELECT_REQ_COVERAGE_USER: "Please select a user for request coverage",
  NO_USER_AVAILABLE_REQ_COVERAGE: "No users available for request coverage",
  PLEASE_ENTER_REQ_COVERAGE_USER_VALUE:
    "Please enter value for required number of users",
  PLEASE_ENTER_USERS_GREATER_THAN_ENTERED_REQ_COVERAGE:
    "Please select users greater than entered required number of users",
  WARNING_MESSAGE:
    "Media message is mandatory  to send text message,To send text message go to message section",
  AUTO_SYNC_ALERT_SUCCESS:
    "Auto Sync Updated..!! Please sync your changes in schedule sync",
  AUTO_SYNC_ALERT_ERROR: "Auto Sync failed",
};

const SBOARD_COLUMN_TYPE = {
  TD: "0",
  TEXT: "1",
  BOOLEAN: "2",
  CODE: "5",
  DROPDOWN_WITH_ICON: "7",
  DROPDOWN: "3",
};
const MOVE_PATIENT = {
  SWAP: {
    id: 2,
    name: "Swap",
  },
  TRANSFER: {
    id: 1,
    name: "Transfer",
  },
  SWAP_TRANSFER: {
    Swap: "Swapped patients successfully!",
    Transfer: "Transferred patient successfully!",
  },
};

const REMINDER_RINGTONE = {
  PATH: "assets/audio/reminder.mp3",
};

const SOCKET_TYPE = {
  CARE_TEAM_ON: 0,
  CARE_TEAM_OFF: 1,
  SWAP_TRANSFER: 2,
  DISCHARGE: 3,
  CARE_TEAM_LIST: 4,
  SUPPORT_STAFF_LIST: 5,
  SUPPORT_STAFF_UPDATE: 6,
  DATATABLE_ROW: 7,
  CUSTOM_COLUMNS: 8,
  ADD_EDIT_PATIENT: 9,
  PRIMARY_MD: 10,
  NURSE_SMS: 11,
  NURSE_UPDATE: 12,
};

const SOCKET_PATH = {
  CARE_TEAM: "sboard/unit/sboard/",
};
const DATATABLE_UPDATE = {
  TITLE: "Update Status Board",
  MESSAGE:
    "There is an update available for the status board. Do you want to update it now?",
};

const CARE_TEAM_CATEGORY = {
  CATEGORY: [
    "icon-liver_care",
    "icon-brain",
    "icon-kidney",
    "icon-call_code",
    "icon-siren",
    "icon-stemi",
    "icon-cardiology",
    "icon-care-team",
  ],
};
const STORAGE_KEYS = [
  "guid",
  "token",
  "userId",
  "network",
  "roles",
  "rolePermissions",
  "isDarkMode",
  "unavilabilityStatus",
];

const STATUS_BOARD_ROWTYPE = {
  CARE_TEAM: 0,
  COMMON_PROVIDER: 1,
};

const ROLES = {
  EMT: "Emergency Medical Technician",
};

const GROUP_LIST_ACTION = {
  ADD: 0,
  DELETE: 1,
  GET: {
    CARE_TEAM: 2,
    COMMON_PROVIDER: 3,
  },
  UPDATE: {
    CARE_TEAM: 4,
    COMMON_PROVIDER: 5,
  },
  SEARCH: {
    CARE_TEAM: 6,
    COMMON_PROVIDER: 7,
  },
};

const PAGER_TYPE = {
  NURSE: "NURSE",
  UNIT: "UNIT",
  NONE: "NONE",
};

const MENU_LIST_ITEMS = {
  HOME: 1,
  CALL_SCHEDULE: 2,
  SITE: 9,
  MY_PATIENTS: 4,
  TEAMS: 5,
  UNASSIGNED_SHIFT: 6,
  NURSE_MANAGEMENT: 7,
  FILE_SHARE: 8,
  MESSAGES: 3,
  CASE_HISTORY: 10,
  STATUS_BOARD: 11,
};

const FOOTER_MENU_LIST_ITEMS = {
  ONCALL_LOOK_UP: 1,
  CALL_SCHEDULE: 2,
  HOME: 3,
  MESSAGES: 4,
  TEAMS: 5,
  SITE: 7,
  MY_PATIENTS: 6,
};

const MENU_SETTINGS_LIST_ITEMS = {
  MY_PROFILE: 1,
  SETTINGS: 2,
  AVAILABILITY_LIST: 3,
  MY_CONTACT_NUMBER: 4,
  SCHEDULE_SYNC: 5,
  HELP: 6,
  ABOUT_US: 7,
  LOG_OUT: 8,
};

const PROVIDER_POPUPTYPE = {
  PRIMARY_MD: "1",
  PROVIDER: "2",
  SUPPORT_STAFF: "SUPPORT_STAFF",
};

const SETTING_OPTIONS = {
  SAVE_PASSWORD: 1,
  UNAVAILABLE_WHEN_NOT_ON_CALL: 2,
  TOGGLE_THEME: 3,
};

const PHONE_NUM_OPTIONS = {
  MOBILE: 1,
  LANDLINE: 2,
};
const REQUEST_TYPE = {
  COVERAGE: 1,
  SWAP: 2,
  AVAILABILITY: 3,
  AVAILABLE_ON_DEMAND: 4,
  SCHEDULING: 5,
  SERVICE: 6,
  EMERGENCY: 7,
};
const ALERT_RINGTONE = {
  ALERT: "assets/audio/reminder.mp3",
};

const MEDIA_TYPE = {
  IMAGE: 1,
  AUDIO: 2,
  VIDEO: 3,
  EKG: 5,
};

const MEDIA_ACTIONS = {
  SEND: "1",
  HISTORY: "2",
  REPLY: "4",
  FORWARD: "3",
  DELETE: "5",
};
const DAYS_ADDED = {
  SCHEDULE: 20,
  END_DATE: 1,
};

const SYNC_DEVICE = {
  GOOGLE: 1,
  OUTLOOK: 2,
  IPHONE: 3,
};

const AUTO_SYNC = {
  GOOGLE: 4,
  OUTLOOK: 5,
};

export const CONSTANTS = {
  STORAGE,
  CALLCENTRAL_CONSTANTS,
  COMPONENTS,
  ROLES,
  MESSAGES,
  SBOARD_COLUMN_TYPE,
  MOVE_PATIENT,
  REMINDER_RINGTONE,
  SOCKET_TYPE,
  SOCKET_PATH,
  DATATABLE_UPDATE,
  CARE_TEAM_CATEGORY,
  PAGER_TYPE,
  MENU_LIST_ITEMS,
  FOOTER_MENU_LIST_ITEMS,
  STATUS_BOARD_ROWTYPE,
  GROUP_LIST_ACTION,
  MENU_SETTINGS_LIST_ITEMS,
  PROVIDER_POPUPTYPE,
  SETTING_OPTIONS,
  PHONE_NUM_OPTIONS,
  REQUEST_TYPE,
  ALERT_RINGTONE,
  MEDIA_TYPE,
  MEDIA_ACTIONS,
  DAYS_ADDED,
  SYNC_DEVICE,
  AUTO_SYNC,
  STORAGE_KEYS,
};
